import React from "react";
import { connect } from "react-redux";

import { DOCUMENTS } from "../../constants";
import {
  getFieldValue,
  isSharedFormDocumentFillable,
} from "../../utils/formFieldUtils";

import RevvEditorInputField from "./RevvEditorInputField";

const { EDITOR_CUSTOM_STYLES_MAP } = DOCUMENTS;

// Declarations
const AVAILABLE_EDITOR_INPUT_FIELDS = {
  CHECKBOX: true,
  RADIO: true,
  TOGGLE: true,
};

const handleDynamicField = props => {
  const { formField: { conditional_logic } = {}, showForm } = props;
  if (conditional_logic && showForm) {
    if (!conditional_logic.show) {
      return null;
    }
  }
  const data = props.contentState.getEntity(props.entityKey).getData();
  let className = "";
  if (
    props.formField &&
    props.formField.type === "NUMBER" &&
    !(data.value === null || data.value === undefined || data.value === "") &&
    data.label
  ) {
    className = "dynamic-field-valid";
  } else if (data.label && data.value) {
    className = "dynamic-field-valid";
  } else if (data.value && data.value !== props.decoratedText) {
    className = "dynamic-field-valid";
  } else className = "dynamic-field";
  // Now, there will be a styles for Dynamic fields also,
  // so here will have to find and apply the all attached styles
  let getStyles = {};
  if (
    props.children[0] &&
    props.children[0].props &&
    props.children[0].props.styleSet
  ) {
    const styles = Array.from(props.children[0].props.styleSet);
    if (styles && styles.length > 0) {
      styles.forEach(style => {
        if (style.startsWith("FONTCOLOR")) {
          const getColor = style.split("_")[1];
          if (getColor) {
            getStyles = {
              ...getStyles,
              // stylelint-disable-next-line
              color: `#${getColor}`,
            };
          }
        } else {
          getStyles = { ...getStyles, ...EDITOR_CUSTOM_STYLES_MAP[style] };
        }
      });
    }
  }
  let fieldValue = data.value;
  if (data.value === null || data.value === undefined || data.value === "") {
    fieldValue = data.label;
  } else if (
    fieldValue === null ||
    fieldValue === undefined ||
    fieldValue === ""
  ) {
    fieldValue = props.decoratedText;
  }

  if (props.fieldValue) {
    fieldValue = props.fieldValue || props.decoratedText;
    // (props.fieldValue ? props.fieldValue : props.formField.label) ||

    if (props.mode === "DOCUMENT") className = "dynamic-field-valid";
  }

  const { quickReviewActive } = props;
  if (quickReviewActive) {
    className = "";
    getStyles = {};
  }

  // font weight bold used for overriding inline styles
  const isShared =
    typeof window !== "undefined" &&
    window.location.pathname.includes("/shared/documents/");
  const isDocInFillingState = isSharedFormDocumentFillable(
    props.docStage,
    props.acceptingStates,
    props.recipientType,
  );

  if (
    isShared &&
    ((isDocInFillingState &&
      props.formField &&
      props.formField.filler_type === "SENDER") ||
      !isDocInFillingState)
  ) {
    className = "";
  }
  if (
    !props.fieldValue &&
    props.docStage !== "DRAFT" &&
    props.metaData &&
    props.metaData.formFieldsSettingsType === "BLANK_WITH_EMPTY"
  ) {
    if (
      // props.docStage === "SENT" ||
      // props.docStage === "COMPLETED" ||
      // props.docStage === "DECLINED" ||
      // props.docStage === "APPROVED" ||
      props.formField &&
      props.formField.filler_type === "SENDER"
    ) {
      return (
        <span
          style={{ display: "none" }}
          data-id={data.dynamicFieldId}
          id={`${data.id}${data.sectionId ? `-${data.sectionId}` : ""}`}
        />
      );
    }
  }

  let showInputField = false;

  let fieldDisplay = null;
  if (props.formField) {
    fieldDisplay = props.formField.field_meta;
    if (props.mode === "TEMPLATE") {
      fieldDisplay = props.formField.meta.display;
    }
  }
  if (
    props.formField &&
    AVAILABLE_EDITOR_INPUT_FIELDS[props.formField.type] &&
    (props.formField.type === "TOGGLE" ||
      (fieldDisplay &&
        (fieldDisplay.show === "all" ||
          (fieldDisplay.show === "selected" &&
            props.mode !== "TEMPLATE" &&
            fieldDisplay.direction === "vertical"))))
  ) {
    showInputField = true;
  }
  if (showInputField) {
    const inputFieldStyles = { ...getStyles };
    delete inputFieldStyles.fontSize;
    return (
      <span
        className={`${className} checkbox-field-wrapper ${
          props.formField.meta.display.direction === "vertical"
            ? "vertically-aligned"
            : ""
        } ${props.formField.type === "TOGGLE" ? " toogle-field " : ""}`}
        id={`${data.id}${data.sectionId ? `-${data.sectionId}` : ""}`}>
        <span data-offset-key={props.offsetKey} style={inputFieldStyles}>
          <span data-text="true" data-id={data.dynamicFieldId}>
            <RevvEditorInputField
              mode={props.mode}
              fieldData={props.formField}
              updateFormRowDataField={props.updateFormRowDataField}
              updateDynamicFieldsInDoc={props.updateDynamicFieldsInDoc}
              currentUser={props.currentUser}
              updateDynamicFieldsInMasterDoc={
                props.updateDynamicFieldsInMasterDoc
              }
              updateEditorStateInSectionForClauseOptions={
                props.updateEditorStateInSectionForClauseOptions
              }
              executeCommand={props.executeCommand}
              styles={getStyles}
              isDocInFillingState={isDocInFillingState}
              docStage={props.docStage}
              placeholderText={props.decoratedText}
              sectionId={props.sectionId}
              inputFieldStyles={inputFieldStyles}
            />
          </span>
        </span>
      </span>
    );
  }

  if (
    props.formField &&
    props.formField.type === "RADIO" &&
    fieldValue === "Other : "
  ) {
    fieldValue = "Other ";
  }

  return (
    <span
      className={className}
      id={`${data.id}${data.sectionId ? `-${data.sectionId}` : ""}`}>
      <span data-offset-key={props.offsetKey} style={getStyles}>
        <span data-text="true" data-id={data.dynamicFieldId}>
          {typeof fieldValue === "object" ? "" : fieldValue}
        </span>
      </span>
    </span>
  );
};

const mapStateToProps = (state, props) => {
  const { template } = state.TemplateStore;
  const { quickReviewActive } = state.MetalensStore;
  const {
    document: {
      // Picking up all fields instead for fields_used to update df's associated with clauses
      all_fields_used: fieldsUsed,
      stage: docStage,
      meta_data: metaData,
      showForm,
    } = {},
  } = state.DocumentStore;
  const { recipientType, acceptingStates } = state.SharedDocument;

  let mode = "DOCUMENT";
  if (template && template.id) mode = "TEMPLATE";

  let formField;
  let fieldValue;

  if (mode === "TEMPLATE") {
    if (
      template &&
      template.fields_used &&
      Array.isArray(template.fields_used)
    ) {
      const data = props.contentState.getEntity(props.entityKey).getData();
      formField = template.fields_used.find(
        field => field.id === data.dynamicFieldId,
      );
      fieldValue = formField ? formField.label : "";
    }
  }

  if (mode === "DOCUMENT") {
    const data = props.contentState.getEntity(props.entityKey).getData();
    if (fieldsUsed && Array.isArray(fieldsUsed)) {
      const fu = fieldsUsed.find(field => field.id === data.dynamicFieldId);
      if (fu) {
        formField = fu;
        fieldValue = getFieldValue(fu, null);
      }
    }
  }
  return {
    mode,
    docStage,
    formField,
    fieldValue,
    quickReviewActive,
    recipientType,
    acceptingStates,
    metaData,
    showForm,
  };
};

export default connect(mapStateToProps, null)(handleDynamicField);
